// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"b91e219ff120ed35","964":"60d757fc8cdaf7ac"}[chunkId] + ".js";
};